import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  Divider,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';
import { Formik } from 'formik';
import * as yup from 'yup';
import { BackdropCircular } from 'components';
import { sendDNSConfigurationsApi } from 'api';
import { dnsData } from './dnsData';


const DNSEmailForm = () => {
  const dispatch = useDispatch();
  const { sendingDNSConfigurations } = useSelector((state) => state.dns_manager);
  return (
    <div className="m-5">
      <Typography variant="h6" className="mb-8 text-dark-gray">
        Enter a coworker&apos;s email address and we&apos;ll send them everything they need to install these records.
      </Typography>
      <Formik
        onSubmit={(values) => sendDNSConfigurationsApi({dispatch, values})}
        initialValues={{
          emailTo: '',
          message: 'Hi, I\'m trying to connect my domain to my new DermPRO Online Store, but I don\'t have the ability to modify our DNS records. Can you help me add these records, so that I can complete the process?',
          data: dnsData
        }}
        validationSchema={
          yup.object({
            emailTo: yup
              .string()
              .email('Enter valid email address')
              .required('Field is required')
          })
        }
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={3} md={2} className="text-right text-muted">
                To: <span className="text-error">*</span>
              </Grid>
              <Grid item xs={12} sm={9}>
                <TextField
                  required
                  fullWidth
                  name="emailTo"
                  placeholder="Email Address"
                  value={values.emailTo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.emailTo && Boolean(errors.emailTo)}
                  helperText={touched.emailTo && errors.emailTo}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={2} className="text-right text-muted">
                Message:
              </Grid>
              <Grid item xs={12} sm={9}>
                <TextField
                  fullWidth
                  multiline
                  name="message"
                  className="mb-5"
                  value={values.message}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  inputProps={{
                    className: 'line-height-1.8'
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12} align="right">
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  className="mx-5"
                >
                  Send
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
      <BackdropCircular loading={sendingDNSConfigurations} title="Sending Email..." />
    </div>
  );
};

export default DNSEmailForm;
